import { useTranslations } from '@vocab/react';
import { Column, Columns, Heading, Stack } from 'braid-design-system';

import appTranslations from 'src/.vocab';
import DancingDots from 'src/App/Components/DancingDots';
import { useHiringAdvice } from 'src/modules/ApiClient';

import translations from './.vocab';
import HiringAdviceItem from './HiringAdviceItem';

const HiringAdvice = () => {
  const { loading, error, data: articles } = useHiringAdvice();
  const { t } = useTranslations(translations);
  const { t: appTrans } = useTranslations(appTranslations);

  if (loading || !articles) {
    return <DancingDots />;
  }

  if (error) {
    return (
      <Heading level="3">
        {appTrans('Error')}: {error.message}
      </Heading>
    );
  }

  return (
    <Stack space="large">
      <Heading level="3">{t('Hiring advice')}</Heading>
      <Columns space="small" collapseBelow="tablet">
        {articles.map((article) => {
          if (article) {
            return (
              <Column key={`article-${article.title}`} width="1/3">
                <HiringAdviceItem
                  imageUrl={article.imageUrl}
                  imageTitle={article.imageTitle}
                  articleTitle={article.title}
                  articleUrl={article.url}
                  timeToRead={article.timeToRead}
                />
              </Column>
            );
          }
          return null;
        })}
      </Columns>
    </Stack>
  );
};

export default HiringAdvice;
